import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@drone-js/core';
import { selectCmsFromBootstrap } from 'store/slice/bootstrap';

export interface CancellationPolicyMessageProps {
    isFreeCancellation: boolean;
}

const CancellationPolicyMessage: React.FC<CancellationPolicyMessageProps> = (props) => {
    const cms = useSelector(selectCmsFromBootstrap);
    const color = props.isFreeCancellation ? 'base.subtle' : 'deprecated.secondary.interactive';

    return (
        <Typography data-testid="activities-cancellation-policy-message" variant="body-s" tag="span" textColor={color} mt="8" mb="8">
            {props.isFreeCancellation ? cms[145602] : cms[130814]}
        </Typography>
    );
};
CancellationPolicyMessage.displayName = 'CancellationPolicyMessage';

export default CancellationPolicyMessage;
